import SEOHead from "@/components/SEOHead";
import SwitchVsStayCalculator from "@/components/SwitchVsStayCalculator";
import TrustBar from "@/components/TrustBar";
import RelatedTools from "@/components/RelatedTools";
import SolutionsCrossSell from "@/components/SolutionsCrossSell";

export default function SwitchVsStayPage() {
  return (
    <div>
      <SEOHead title="Switch vs Stay Calculator" description="Should you switch payment provider? Use our free calculator to see if switching would save you money and how long it would take to break even." path="/switch-vs-stay" />

      <section className="py-10 md:py-16 bg-gray-50" id="calculator" data-testid="calculator-section">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-6">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-aqua mb-2">Switch vs Stay</p>
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-brand-black tracking-tight mb-3">Is switching worth it?</h1>
            <p className="text-brand-grey leading-relaxed max-w-xl mx-auto">Enter your current and estimated new costs. We&apos;ll show you the break-even point and first-year net saving instantly.</p>
          </div>
          <SwitchVsStayCalculator />
        </div>
      </section>

      <TrustBar />

      <RelatedTools currentPath="/switch-vs-stay" />
      <SolutionsCrossSell currentPath="/switch-vs-stay" />
    </div>
  );
}
